"use client"
import Link from 'next/link'
import { useEffect, useState } from 'react'
import { createPortal } from 'react-dom'
import { usePathname } from 'next/navigation'
import { Menu, X } from 'lucide-react'

export default function SiteHeaderClient() {
  const [mobileOpen, setMobileOpen] = useState(false)
  const close = () => setMobileOpen(false)
  const pathname = usePathname()
  const [mounted, setMounted] = useState(false)

  // Close menu on route change (e.g., navigating to a product page)
  useEffect(() => {
    setMobileOpen(false)
  }, [pathname])

  // Prevent body scroll while mobile menu is open
  useEffect(() => {
    try {
      document.body.style.overflow = mobileOpen ? 'hidden' : ''
    } catch {}
    return () => { try { document.body.style.overflow = '' } catch {} }
  }, [mobileOpen])

  useEffect(() => setMounted(true), [])
  return (
    <header className="sticky top-0 z-50 backdrop-blur bg-white/80 border-b">
      <div className="mx-auto max-w-6xl px-4 py-3 flex items-center justify-between relative">
        <Link href="/" className="inline-flex items-center gap-px" onClick={close}>
          <img src="/assets/brand/logo/favicon.png" alt="Saffron Leo" className="h-10 w-10" width="40" height="40" />
          <span className="block text-lg font-semibold text-brand capitalize leading-4 font-serif whitespace-normal">Saffron Leo</span>
        </Link>
        {/* Desktop nav */}
        <nav className="hidden md:flex text-sm items-center gap-6">
          <Link href="/explore/" className="text-black hover:text-black hover:underline">Explore</Link>
          <Link href="/blog/" className="text-black hover:text-black hover:underline">Blog</Link>
          <Link href="/care/" className="text-black hover:text-black hover:underline">Care</Link>
          <Link href="/about/" className="text-black hover:text-black hover:underline">About</Link>
          <Link href="/contact/" className="text-black hover:text-black hover:underline">Contact</Link>
        </nav>
        {/* Mobile nav button */}
        <button type="button" className="md:hidden inline-flex h-10 w-10 items-center justify-center rounded border bg-white text-gray-700 shadow-sm" aria-label={mobileOpen ? 'Close menu' : 'Open menu'} onClick={() => setMobileOpen(v => !v)}>
          {mobileOpen ? <X size={18} /> : <Menu size={18} />}
        </button>
        {/* Mobile dropdown */}
        {mobileOpen && (
          <>
            <div className="absolute right-0 top-full mt-2 w-56 rounded border bg-white p-2 text-sm shadow-xl ring-1 ring-black/10 md:hidden z-60">
              <Link href="/explore/" onClick={close} className="block rounded px-3 py-2 text-black hover:text-black hover:bg-gray-50">Explore</Link>
              <Link href="/blog/" onClick={close} className="block rounded px-3 py-2 text-black hover:text-black hover:bg-gray-50">Blog</Link>
              <Link href="/care/" onClick={close} className="block rounded px-3 py-2 text-black hover:text-black hover:bg-gray-50">Care</Link>
              <Link href="/about/" onClick={close} className="block rounded px-3 py-2 text-black hover:text-black hover:bg-gray-50">About</Link>
              <Link href="/contact/" onClick={close} className="block rounded px-3 py-2 text-black hover:text-black hover:bg-gray-50">Contact</Link>
            </div>
            {/* Backdrop rendered via portal so it covers full viewport (not clipped by header) */}
            {mounted && createPortal(
              <button aria-label="Close menu" onClick={close} className="fixed inset-0 z-30 bg-black/40 md:hidden" />,
              document.body
            )}
          </>
        )}
      </div>
    </header>
  )
}
